export const aqsColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "thunderboard_temp", isChecked: false },
  { id: 3, value: "thunderboard_humidity", isChecked: false },
  { id: 4, value: "thunderboard_illuminance", isChecked: false },
  { id: 5, value: "thunderboard_illuminance_index", isChecked: false },
  { id: 6, value: "thunderboard_accelarationx", isChecked: false },
  { id: 7, value: "thunderboard_accelarationy", isChecked: false },
  { id: 8, value: "thunderboard_accelarationz", isChecked: false },
  { id: 9, value: "thunderboar_dbio_pressure", isChecked: false },
  { id: 10, value: "thunderboard_sound_pressure", isChecked: false },
  { id: 11, value: "thunderboard_co2", isChecked: false },
  { id: 12, value: "thunderboard_tvoc", isChecked: false },
  { id: 13, value: "thermister_temp", isChecked: false },
  { id: 14, value: "thermister_humidity", isChecked: false },
  { id: 15, value: "foxberry_co2", isChecked: false },
  { id: 16, value: "foxberry_temp", isChecked: false },
  { id: 17, value: "sdc40_co2", isChecked: false },
  { id: 18, value: "sdc40_temp", isChecked: false },
  { id: 19, value: "sgp40_voc_index", isChecked: false },
  { id: 20, value: "fs_wind_speed", isChecked: false },
  { id: 21, value: "fs_wind_speed_count", isChecked: false },
  { id: 22, value: "three_sp_co", isChecked: false },
  { id: 23, value: "three_sp_no2", isChecked: false },
  { id: 24, value: "three_sp_o3", isChecked: false },
  { id: 25, value: "sps30_pm1", isChecked: false },
  { id: 26, value: "sps30_pm2", isChecked: false },
  { id: 27, value: "sps30_pm4", isChecked: false },
  { id: 28, value: "sps30_pm10", isChecked: false },
  { id: 29, value: "sht30_temp", isChecked: false },
  { id: 30, value: "sht30_humidity", isChecked: false },
  { id: 31, value: "bcc", isChecked: false },
  { id: 32, value: "three_sp_so2", isChecked: false }
];

export const fdsColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "thermister_temp", isChecked: false },
  { id: 3, value: "thermister_humidity", isChecked: false },
  { id: 4, value: "slightdifferentialpressure", isChecked: false },
  { id: 5, value: "sps30_2_pm1_0_mass", isChecked: false },
  { id: 6, value: "sps30_2_pm2_5_mass", isChecked: false },
  { id: 7, value: "sps30_2_pm10_0_mass", isChecked: false },
  { id: 8, value: "sps30_2_pm0_5_number", isChecked: false },
  { id: 9, value: "sps30_2_pm1_0_number", isChecked: false },
  { id: 10, value: "sps30_3_pm1_0_mass", isChecked: false },
  { id: 11, value: "sps30_3_pm2_5_mass", isChecked: false },
  { id: 12, value: "sps30_3_pm10_mass", isChecked: false },
  { id: 13, value: "sps30_3_pm0_5_number", isChecked: false },
  { id: 14, value: "sps30_3_pm1_0_number", isChecked: false },
  { id: 15, value: "sht30_temp", isChecked: false },
  { id: 17, value: "sht30_humidity", isChecked: false },
  { id: 18, value: "fs_wind_speed", isChecked: false },
  { id: 19, value: "fs_wind_speed_count", isChecked: false },
  { id: 20, value: "bcc", isChecked: false }
];

export const aqs2ColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "battery_voltage", isChecked: false },
  { id: 3, value: "thunderboard_temp", isChecked: false },
  { id: 4, value: "thunderboard_humidity", isChecked: false },
  { id: 5, value: "thunderboard_magnetism", isChecked: false },
  { id: 6, value: "thunderboard_accelarationx", isChecked: false },
  { id: 7, value: "thunderboard_accelarationy", isChecked: false },
  { id: 8, value: "thunderboard_accelarationz", isChecked: false },
  { id: 9, value: "thunderboar_baro_pressure", isChecked: false },
  { id: 10, value: "thunderboard_sound_pressure", isChecked: false },
  { id: 11, value: "thunderboard_co2", isChecked: false },
  { id: 12, value: "thunderboard_tvoc", isChecked: false },
  { id: 13, value: "thermister1_temp", isChecked: false },
  { id: 14, value: "thermister2_temp", isChecked: false },
  { id: 15, value: "foxberry_co2", isChecked: false },
  { id: 16, value: "foxberry_temp", isChecked: false },
  { id: 17, value: "sdc40_co2", isChecked: false },
  { id: 18, value: "sdc40_temp", isChecked: false },
  { id: 19, value: "foxberry_co2_avg", isChecked: false },
  { id: 20, value: "foxberry_co2_max", isChecked: false },
  { id: 21, value: "foxberry_co2_min", isChecked: false },
  { id: 22, value: "foxberry_temp_avg", isChecked: false },
  { id: 23, value: "foxberry_temp_max", isChecked: false },
  { id: 24, value: "foxberry_temp_min", isChecked: false },
  { id: 25, value: "sdc40_co2_avg", isChecked: false },
  { id: 26, value: "sdc40_co2_max", isChecked: false },
  { id: 27, value: "sdc40_co2_min", isChecked: false },
  { id: 28, value: "sdc40_temp_avg", isChecked: false },
  { id: 29, value: "sdc40_temp_max", isChecked: false },
  { id: 30, value: "sdc40_temp_min", isChecked: false },
  { id: 31, value: "slight_diff_pressure1", isChecked: false },
  { id: 33, value: "sps30_pm1_mass_conc", isChecked: false },
  { id: 34, value: "sps30_pm2_mass_conc", isChecked: false },
  { id: 35, value: "sps30_pm10_mass_conc", isChecked: false },
  { id: 36, value: "sps30_pm5_no_conc", isChecked: false },
  { id: 37, value: "sps30_pm1_no_conc", isChecked: false },
  { id: 38, value: "three_sp_no2", isChecked: false },
  { id: 39, value: "three_sp_o3", isChecked: false },
  { id: 40, value: "three_sp_so2", isChecked: false },
  { id: 41, value: "fecs44_ammonia", isChecked: false },
  { id: 42, value: "tgs5141_co", isChecked: false },
  { id: 43, value: "human_det_1_ratio", isChecked: false },
  { id: 44, value: "human_det_1_number", isChecked: false },
  { id: 45, value: "human_det_2_ratio", isChecked: false },
  { id: 46, value: "human_det_2_number", isChecked: false },
  { id: 47, value: "human_det_3_ratio", isChecked: false },
  { id: 48, value: "human_det_3_number", isChecked: false },
  { id: 49, value: "human_det_4_ratio", isChecked: false },
  { id: 50, value: "human_det_4_number", isChecked: false },
  { id: 51, value: "wind_speed_avg", isChecked: false },
  { id: 52, value: "wind_speed_max", isChecked: false },
  { id: 53, value: "wind_speed_min", isChecked: false },
  { id: 54, value: "wind_direction", isChecked: false },
  { id: 55, value: "bm1422_geomagnetism", isChecked: false },
  { id: 56, value: "sht30_temp", isChecked: false },
  { id: 57, value: "sht30_humidity", isChecked: false },
  { id: 58, value: "bh1721_illuminance", isChecked: false },
  { id: 59, value: "bcc", isChecked: false }
];

export const fds2ColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "battery_voltage", isChecked: false },
  { id: 3, value: "thunderboard_temp", isChecked: false },
  { id: 4, value: "thunderboard_humidity", isChecked: false },
  { id: 5, value: "thunderboard_magnetism", isChecked: false },
  { id: 6, value: "thunderboard_accelarationx", isChecked: false },
  { id: 7, value: "thunderboard_accelarationy", isChecked: false },
  { id: 8, value: "thunderboard_accelarationz", isChecked: false },
  { id: 9, value: "thunderboar_baro_pressure", isChecked: false },
  { id: 10, value: "thunderboard_sound_pressure", isChecked: false },
  { id: 11, value: "thunderboard_co2", isChecked: false },
  { id: 12, value: "thunderboard_tvoc", isChecked: false },
  { id: 13, value: "thermister1_temp", isChecked: false },
  { id: 14, value: "thermister2_temp", isChecked: false }, 
  { id: 15, value: "slight_diff_pressure1", isChecked: false },
  { id: 17, value: "sps30_2_pm1_mass_conc", isChecked: false },
  { id: 18, value: "sps30_2_pm2_mass_conc", isChecked: false },
  { id: 19, value: "sps30_2_pm10_mass_conc", isChecked: false },
  { id: 20, value: "sps30_2_pm5_no_conc", isChecked: false },
  { id: 21, value: "sps30_2_pm1_no_conc", isChecked: false },
  { id: 22, value: "sps30_3_pm1_mass_conc", isChecked: false },
  { id: 23, value: "sps30_3_pm2_mass_conc", isChecked: false },
  { id: 24, value: "sps30_3_pm10_mass_conc", isChecked: false },
  { id: 25, value: "sps30_3_pm5_no_conc", isChecked: false },
  { id: 26, value: "sps30_3_pm1_no_conc", isChecked: false },
  { id: 27, value: "sht30_temp", isChecked: false },
  { id: 28, value: "sht30_humidity", isChecked: false },
  { id: 29, value: "fs3000_wind_speed", isChecked: false },
  { id: 30, value: "fs3000_wind_speed_count", isChecked: false }, 
  { id: 31, value: "bcc", isChecked: false }
];

export const tisColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "battery_voltage", isChecked: false },
  { id: 3, value: "thunderboard_temp", isChecked: false },
  { id: 4, value: "thunderboard_humidity", isChecked: false },
  { id: 5, value: "thunderboard_magnetism", isChecked: false },
  { id: 6, value: "thunderboard_accelarationx", isChecked: false },
  { id: 7, value: "thunderboard_accelarationy", isChecked: false },
  { id: 8, value: "thunderboard_accelarationz", isChecked: false },
  { id: 9, value: "thunderboar_baro_pressure", isChecked: false },
  { id: 10, value: "thunderboard_sound_pressure", isChecked: false },
  { id: 11, value: "thunderboard_co2", isChecked: false },
  { id: 12, value: "thunderboard_tvoc", isChecked: false },
  { id: 13, value: "weight_load_cell_1", isChecked: false },
  { id: 14, value: "weight_load_cell_2", isChecked: false },
  { id: 15, value: "sdc40_co2", isChecked: false }, 
  { id: 16, value: "slight_diff_press_15_0_avg", isChecked: false },
  { id: 17, value: "slight_diff_press_15_0_max", isChecked: false },
  { id: 18, value: "slight_diff_press_15_0_min", isChecked: false },
  { id: 19, value: "temp_airvelocity_avg", isChecked: false },
  { id: 20, value: "hum_airvelocity_avg", isChecked: false },
  { id: 21, value: "temp_airvelocity_max", isChecked: false },
  { id: 22, value: "hum_airvelocity_max", isChecked: false },
  { id: 23, value: "temp_airvelocity_min", isChecked: false },
  { id: 24, value: "hum_airvelocity_min", isChecked: false },
  { id: 25, value: "wind_speed_avg", isChecked: false },
  { id: 26, value: "wind_speed_count_avg", isChecked: false },
  { id: 27, value: "wind_speed_max", isChecked: false },
  { id: 28, value: "wind_speed_count_max", isChecked: false },
  { id: 29, value: "wind_speed_min", isChecked: false },
  { id: 30, value: "wind_speed_count_min", isChecked: false },
  { id: 31, value: "vib_board_acc_x_avg", isChecked: false },
  { id: 32, value: "vib_board_acc_y_avg", isChecked: false },
  { id: 33, value: "vib_board_acc_z_avg", isChecked: false },
  { id: 34, value: "vib_board_acc_x_max", isChecked: false },
  { id: 35, value: "vib_board_acc_y_max", isChecked: false },
  { id: 36, value: "vib_board_acc_z_max", isChecked: false },
  { id: 37, value: "vib_board_acc_x_min", isChecked: false },
  { id: 38, value: "vib_board_acc_y_min", isChecked: false },
  { id: 39, value: "vib_board_acc_z_min", isChecked: false },
  { id: 40, value: "current_avg", isChecked: false },
  { id: 41, value: "current_max", isChecked: false },
  { id: 42, value: "current_min", isChecked: false }, 
  { id: 43, value: "bcc", isChecked: false }
];

export const psColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "header", isChecked: false },
  { id: 3, value: "battery_voltage", isChecked: false },
  { id: 4, value: "avgpower_0015", isChecked: false },
  { id: 5, value: "avgpower_1530", isChecked: false },
  { id: 6, value: "avgpower_3045", isChecked: false },
  { id: 7, value: "avgpower_4560", isChecked: false },
  { id: 8, value: "dateno", isChecked: false },
  { id: 9, value: "temperature", isChecked: false },
  { id: 10, value: "humidity", isChecked: false },
  { id: 11, value: "bcc", isChecked: false }
];

export const aqs3ColumnList = [
  { id: 0, value: "SelectAll", isChecked: false },
  { id: 1, value: "imsi", isChecked: false },
  { id: 2, value: "battery_voltage", isChecked: false },
  { id: 3, value: "data_count", isChecked: false },
  { id: 4, value: "serial_number", isChecked: false },
  { id: 5, value: "temp_sht30", isChecked: false },
  { id: 6, value: "humidity_sht30", isChecked: false },
  { id: 7, value: "co2_sunrise", isChecked: false },
  { id: 8, value: "co_figaro", isChecked: false },
  { id: 9, value: "airflow_koa", isChecked: false },
  { id: 10, value: "pm_01_sps30_m3", isChecked: false },
  { id: 11, value: "pm_25_sps30_m3", isChecked: false },
  { id: 12, value: "pm_04_sps30_m3", isChecked: false },
  { id: 13, value: "pm_10_sps30_m3", isChecked: false },
  { id: 14, value: "pm_05_sps30_cm3", isChecked: false },
  { id: 15, value: "pm_01_sps30_cm3", isChecked: false },
  { id: 16, value: "pm_25_sps30_cm3", isChecked: false },
  { id: 17, value: "pm_04_sps30_cm3", isChecked: false },
  { id: 18, value: "pm_10_sps30_cm3", isChecked: false },
  { id: 19, value: "voc", isChecked: false },
  { id: 20, value: "tvoc_iaq", isChecked: false },
  { id: 21, value: "tvoc_oaq", isChecked: false },
  { id: 22, value: "air_pressure", isChecked: false },
  { id: 23, value: "temp_sht30_min", isChecked: false },
  { id: 24, value: "temp_sht30_max", isChecked: false },
  { id: 25, value: "temp_sht30_avg", isChecked: false },
  { id: 26, value: "humidity_sht30_min", isChecked: false },
  { id: 27, value: "humidity_sht30_max", isChecked: false },
  { id: 28, value: "humidity_sht30_avg", isChecked: false },
  { id: 29, value: "co2_sunrise_min", isChecked: false },
  { id: 30, value: "co2_sunrise_max", isChecked: false },
  { id: 31, value: "co2_sunrise_avg", isChecked: false },
  { id: 32, value: "co_figaro_min", isChecked: false },
  { id: 33, value: "co_figaro_max", isChecked: false },
  { id: 34, value: "co_figaro_avg", isChecked: false },
  { id: 35, value: "airflow_koa_min", isChecked: false },
  { id: 36, value: "airflow_koa_max", isChecked: false },
  { id: 37, value: "airflow_koa_avg", isChecked: false },
  { id: 38, value: "pm_01_sps30_m3_min", isChecked: false },
  { id: 39, value: "pm_01_sps30_m3_max", isChecked: false },
  { id: 40, value: "pm_01_sps30_m3_avg", isChecked: false },
  { id: 41, value: "pm_25_sps30_m3_min", isChecked: false },
  { id: 42, value: "pm_25_sps30_m3_max", isChecked: false },
  { id: 43, value: "pm_25_sps30_m3_avg", isChecked: false },
  { id: 44, value: "pm_04_sps30_m3_min", isChecked: false },
  { id: 45, value: "pm_04_sps30_m3_max", isChecked: false },
  { id: 46, value: "pm_04_sps30_m3_avg", isChecked: false },
  { id: 47, value: "pm_10_sps30_m3_min", isChecked: false },
  { id: 48, value: "pm_10_sps30_m3_max", isChecked: false },
  { id: 49, value: "pm_10_sps30_m3_avg", isChecked: false },
  { id: 50, value: "voc_min", isChecked: false },
  { id: 51, value: "voc_max", isChecked: false },
  { id: 52, value: "voc_avg", isChecked: false },
  { id: 53, value: "tvoc_iaq_min", isChecked: false },
  { id: 54, value: "tvoc_iaq_max", isChecked: false },
  { id: 55, value: "tvoc_iaq_avg", isChecked: false },
  { id: 56, value: "tvoc_oaq_min", isChecked: false },
  { id: 57, value: "tvoc_oaq_max", isChecked: false },
  { id: 58, value: "tvoc_oaq_avg", isChecked: false },
];